import HeaderPdf from './pdfparts/header'

const LearningStyle = ({ data, selectedUser }) => {
  const progressData = [
    {
      titleA: 'Kinesthetic',
      titleB: 'Learners',
      percentage: data.interactive[0],
      bgColor: '#1851fe',
      borderColor: 'rgb(13 110 253 / 30%)',
      trend: `Kinesthetic learners thrive in hands-on activities, excelling through movement and touch.`,
    },
    {
      titleA: 'Auditory',
      titleB: 'Learners',
      percentage: data.audio[0],
      bgColor: '#00bdc3',
      borderColor: 'rgb(3 189 195 / 30%)',
      trend: `Auditory learners excel in environments emphasizing listening, speaking, and verbal instruction.`,
    },
    {
      titleA: 'Visual',
      titleB: 'Learners',
      percentage: data.photos[0],
      bgColor: '#f5457a',
      borderColor: 'rgb(245 70 122 / 30%)',
      trend: `Visual learners thrive in environments utilizing visual aids, diagrams, and images.`,
    },
    {
      titleA: 'Audio-visual',
      titleB: 'Learners',
      percentage: data.videos[0],
      bgColor: '#eca549',
      borderColor: 'rgb(235 165 73/ 30%)',
      trend: `Audio-visual learners excel with information presented through auditory and visual methods.`,
    },
  ]

  const generalTrendDescOrder = Object.entries({ ...data })
    .map(([key, val]) => {
      let newKeys = {
        interactive: 'interactive',
        videos: 'video',
        audio: 'auditory',
        photos: 'visual cues',
      }

      return { name: newKeys[key], perc: Math.round(val[2]) }
    })
    .sort((a, b) => b.perc - a.perc)

  const userDataDescOrder = Object.entries({ ...data })
    .map(([key, val]) => {
      let newKeys = {
        interactive: 'Kinesthetic',
        videos: 'audio-visuals',
        audio: 'audio',
        photos: 'visual cues',
      }

      return { name: newKeys[key], perc: Math.round(val[0]) }
    })
    .sort((a, b) => b.perc - a.perc)

  return (
    <div className='main-container page8-container'>
      <HeaderPdf />

      <div className='pdf-content-container'>
        <div className='heading-seprator'>
          <h1>
            <span>LEARNING PROFILE</span>
          </h1>
          <div className='report-content'>
            <p>
              A learning style profile captures an individual's preferred methods of acquiring and processing
              information, including visual, auditory, and kinesthetic modalities. It identifies the most effective ways
              an individual absorbs and retains knowledge.
            </p>
            <div className='listing-container'>
              <h2>General Trends</h2>
              <p>
                Combining interactive or video-based content is generally more effective for learning than relying
                solely on simple audio or visuals.
              </p>
              <p>
                <span className='text-capitalize'>{generalTrendDescOrder[0].name} </span> content is preferred by{' '}
                {generalTrendDescOrder[0].perc}% of learners, surpassing {generalTrendDescOrder[1].name} learning at{' '}
                {generalTrendDescOrder[1].perc}%, {generalTrendDescOrder[2].name} at {generalTrendDescOrder[2].perc}%,
                and sole reliance on {generalTrendDescOrder[3].name} methods at {generalTrendDescOrder[3].perc}%.
              </p>
              <h2 className='bold_text'>
                For <span className='text-capitalize'>{selectedUser.label}</span>,
              </h2>
              {/* <p>The below cards are in descending order, use first two as best pick for training</p> */}
              <ul className='progress_list'>
                {progressData
                  .sort((a, b) => b.percentage - a.percentage)
                  .map((item, index) => (
                    <li key={index} className='bg-white border p-2 pt-0'>
                      <div
                        className='mx-auto text-white px-2 py-3'
                        style={{
                          background: item.bgColor,
                          width: '95%',
                          borderBottomLeftRadius: '24px',
                          borderBottomRightRadius: '24px',
                        }}
                      >
                        <span>
                          {item.titleA} <br /> {item.titleB}
                        </span>
                      </div>

                      <div
                        className='mx-auto my-2 rounded-circle d-flex align-items-center justify-content-center'
                        style={{
                          height: '90px',
                          width: '90px',
                          border: `8px solid ${item.borderColor}`,
                        }}
                      >
                        <div
                          className='rounded-circle d-flex align-items-center justify-content-center fs-6 text-white'
                          style={{
                            height: '50px',
                            width: '50px',
                            fontFamily: 'sorabold',
                            background: item.bgColor,
                          }}
                        >
                          {Math.round(item.percentage)}%
                        </div>
                      </div>
                      {/* <span style={{ color: item.bgColor }}>General Trends:</span> */}
                      {/* <br /> */}
                      <p style={{ color: item.bgColor }}>{item.trend}</p>
                    </li>
                  ))}
              </ul>
              {/* <p style={{ textAlign: 'justify' }}>
                {selectedUser.gender === 'male' ? 'His' : selectedUser.gender === 'female' ? 'Her' : 'Their'} learning
                profile leans heavily towards {userDataDescOrder[0].name}, The next preference is for{' '}
                {userDataDescOrder[1].name}, finding efficiency in {userDataDescOrder[2].name}, and considering{' '}
                {userDataDescOrder[3].name} as the last option. Relying solely on {userDataDescOrder[3].name} can lead to
                feeling lost or zoned out, negatively impacting learning and cognitive utilization. Applying this
                awareness in education or career can help individuals acknowledge and enhance their cognition,
                ultimately benefiting mental health and reducing mental stress when processing information for optimal
                functioning and excellence.
              </p> */}
            </div>
          </div>
        </div>
        <footer>
          <h6>07</h6>
        </footer>
      </div>
    </div>
  )
}
export default LearningStyle
